export default "__VITE_ASSET__0tqEz7cZ__"